module.exports = new __parcel__URL__("GOES_story_card_image.d0f332be.png").toString();